import { Component, OnInit, ViewChild, Inject, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { ManageBannerService } from './manage-banner.service';
import { TCCPConstantValues } from '../../shared/models/tccp-constants';
import { environment } from '../../../environments/environment';
import { TCCPCommonService } from '../../shared/services/tccp-common.service';
import { Banner } from '../../shared/models/Banner';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table'
import { TCCPLocalStorageService } from '../../shared/services/tccp-local-storage.service';
import { SelectionModel } from '@angular/cdk/collections';
import { AdminService } from '../admin.service';
import { ConfirmModalComponent } from '../../shared/components/confirm-modal/confirm-modal.component';
import _ from 'lodash';
import { MsalService } from '@azure/msal-angular';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-manage-banner',
  templateUrl: './manage-banner.component.html',
  styleUrls: ['./manage-banner.component.scss']
})
export class ManageBannerComponent implements OnInit {
  public bannerStatusList = [];
  public bannerStatus = 'Publish';
  public pageTitle = 'Manage Banner';

  @ViewChild(MatSort, { static: false  }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false  }) paginator: MatPaginator;
  selection = new SelectionModel< Banner >(true, []);
  public selectedApplication: string = this.adminService.selectedApplication;
  public bannerList: Banner[] = [];
  public bannerDataSource = new MatTableDataSource([]);
  public isPermissionExists = false ;
  public displayedColumns: string[] = [];
  public success = [];
  public failure = [];
  public alerts = [];
  public banner: Banner = < Banner > {};

  constructor(
    private cdr: ChangeDetectorRef,
    private router: Router, private bannerService: ManageBannerService,
    private storageService: TCCPLocalStorageService, private authService: MsalService,
    private adminService: AdminService, private dialog: MatDialog, public commonService: TCCPCommonService) {
    this.bannerStatusList = [{ name: 'Published', value: 'Publish' }, { name: 'Draft', value: 'Draft' }];
    this.bannerStatus = 'Publish';
  }

  ngOnInit() {
    this.setUserPolicy();
    this.success = [];
    this.failure = [];
    this.alerts = [];
    this.getBanners('Publish');
  }

  async setUserPolicy(): Promise< void > {
    this.isPermissionExists = false;
    try {
      let roles = this.storageService.getRoles();
      if (!roles) {
        const upn = this.storageService.getUpn();
        const data = await firstValueFrom(this.commonService.getAccessRole(upn));
        roles = _.map(data, 'roles');
        this.storageService.setRoles(roles);
      }
      this.isPermissionExists = !!roles?.includes('CTContentPublisherUser');
    } catch {
      this.isPermissionExists = false;
    }
  }

  public showAlertMessages(messageType, message) {
    this.alerts = [];
    if (this.alerts.length === 0) {
      this.alerts.push({
        type: messageType,
        msg: message
      });
    }
    window.scroll(0, 0);
  }

  closeAlerts() {
    this.alerts = [];
  }

  closeFailure() {
    this.failure = [];
  }

  closeSuccess() {
    this.success = [];
  }

  onTabChanged(event?) {
    this.success = [];
    this.failure = [];
    this.alerts = [];
    this.selection = new SelectionModel< Banner >(true, []);
    if (event === undefined) {
      this.getBanners('Publish');
    } else {
      this.bannerStatus = event.tab.textLabel === 'Published' ? 'Publish' : 'Draft';
      this.getBanners(this.bannerStatus);
    }
  }

  public getBanners(status: string) {
    this.bannerService.getBanner(this.selectedApplication, status).subscribe(response => {
      if (response) {
        if (this.bannerStatus === 'Draft') {
          this.displayedColumns = ['select', 'title',
            'contentType', 'category', 'createdBy', 'createdAt'];
        } else {
          this.displayedColumns = ['select', 'title',
            'contentType', 'category', 'updatedBy', 'updatedAt'];
        }

        if (this.isPermissionExists && this.bannerStatus === 'Draft') {
          this.displayedColumns.push('action');
        }
        this.bannerList = response;
        this.bannerDataSource.data = [];
        response.map(x => {
          const formattedJSON: Banner = < Banner > {};
          const formattedArray = [];
          formattedJSON.title = x.title;
          formattedJSON.contentType = x.contentType;
          formattedJSON.category = x.category;
          formattedJSON.division = x.division;
          formattedJSON.content = x.content;
          formattedJSON.updatedAt = x.updatedAt;
          formattedJSON.updatedBy = x.updatedBy;
          formattedJSON.id = x.id;
          formattedJSON.status = x.status;
          formattedArray.push(formattedJSON);
          this.bannerDataSource.data.push(formattedJSON);
        });

        setTimeout(() => {
          let sortedContents = [];
          sortedContents = this.bannerDataSource.data.sort((obj1, obj2) =>
            obj1.createdAt < obj2.createdAt ? 1 : -1);
          this.bannerDataSource.data = sortedContents;
          this.bannerDataSource.sort = this.sort;
          this.bannerDataSource.paginator = this.paginator;
          this.cdr.detectChanges();
        });

        this.bannerDataSource.filterPredicate = (data: any, filter) => {
          const dataStr = JSON.stringify(data).toLowerCase();
          return dataStr.indexOf(filter) !== -1;
        };
      }
    }, () => {
      this.showAlertMessages('error', 'Unable to load banners. Please try again.');
    });
  }

  applyFilter(filterValue: string) {
    this.bannerDataSource.filter = filterValue.trim().toLowerCase();
  }

  onEdit(row) {
    this.bannerService.pageMode = 'edit';
    this.bannerService.selectedBanner = row;
    this.router.navigateByUrl('/admin/add-banner');
  }

  onDelete(row) {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '350px',
      data: TCCPConstantValues.admin.messages.BANNER_DELETE_CONFIRMATION_MESSAGE
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.bannerService.deleteBanner(row.id, this.selectedApplication).subscribe(response => {
          if (response) {
            this.showAlertMessages('success', TCCPConstantValues.admin.messages.BANNER_DELETE_SUCCESS_MESSAGE);
            this.getBanners(this.bannerStatus);
          }
        });
      }
    });
  }

  public goToAddBanner() {
    this.bannerService.pageMode = 'add';
    this.router.navigateByUrl('/admin/add-banner');
  }

  statusDialog() {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '350px',
      data: TCCPConstantValues.admin.messages.BANNER_PUBLISH_CONFIRMATION_MESSAGE,
      position: { top: '100px' }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

      }
    });
  }
  moveToDraft() {
    this.success = [];
    this.failure = [];
    this.alerts = [];
    const selectedBannerList = this.selection.selected.map(x => x.id );
    this.callUpdateStatus(selectedBannerList, this.bannerStatus);
  }

  moveToPublish() {
    this.success = [];
    this.failure = [];
    this.alerts = [];
    const selectedBannerList = this.selection.selected.map(x => x.id );
    const selectedBannerTypeList = this.selection.selected.map(x => x.contentType);
    let hasPublishedBanner = false ;
    if (selectedBannerTypeList.indexOf('Both') > -1 && selectedBannerTypeList.length > 1) {
      this.showAlertMessages('error', TCCPConstantValues.admin.messages.BANNER_PUBLISH_CONFIRMATION_MESSAGE);
    } else {
      if (selectedBannerTypeList.length === _.uniq(selectedBannerTypeList).length) {
        this.bannerService.getBanner(this.selectedApplication, 'Publish').subscribe(response => {
          if (response) {
            const publishedBannerTypeList = response.map(x => x.contentType);
            selectedBannerTypeList.forEach(x => {
              if (x === 'Both' && publishedBannerTypeList.length > 0) {
                hasPublishedBanner = true;
                this.showAlertMessages('error', TCCPConstantValues.admin.messages.BANNER_PUBLISH_CONFIRMATION_MESSAGE);
              } else {
                if (!hasPublishedBanner) {
                  if (publishedBannerTypeList.indexOf('Both') > -1 || publishedBannerTypeList.indexOf(x) > -1) {
                    if (!hasPublishedBanner) {
                      hasPublishedBanner = true;
                    }
                  }
                }
              }
            });
            if (!hasPublishedBanner) {
              this.callUpdateStatus(selectedBannerList, this.bannerStatus);
            } else {
              this.showAlertMessages('error', TCCPConstantValues.admin.messages.BANNER_PUBLISH_CONFIRMATION_MESSAGE);
            }
          }
        });
      } else {
        this.showAlertMessages('error', TCCPConstantValues.admin.messages.BANNER_PUBLISH_CONFIRMATION_MESSAGE);
      }
    }
  }

  callUpdateStatus(selectedBannerList, status) {
    const bannerStatus = this.bannerStatus !== 'Publish' ? 'Publish' : 'Draft';
    const requestParameter = { bannerIds: selectedBannerList, userid: this.authService.instance.getActiveAccount().username };
    this.bannerService.updateStatus(requestParameter, this.selectedApplication, bannerStatus).subscribe(data => {
      if (data) {
        if (data === '{}') {
          this.selection.selected.forEach(element => {
            this.success.push({
              banner: element.title,
              msg: bannerStatus === 'Publish' ? 'The following Banner(s) are succesfully Published.' :
                'The following Banner(s) moved to Draft Successfully'
            });
          });
          this.selection = new SelectionModel< Banner >(true, []);
          this.getBanners(this.bannerStatus);
        } else {
          this.selection.selected.forEach(element => {
            this.failure.push({
              banner: element.title,
              msg: 'Error While Updating status for the following Banner(s)'
            });
          });
        }
      }
    });
  }

  previewBanner() {
    this.commonService.hideBanner.emit(false);
    this.storageService.setbannerCloseStatus(false);
    environment.applicationName = this.adminService.selectedApplication;
    if (this.selection.selected.length > 1) {
      this.showAlertMessages('error', 'Please select one Banner to see Preview');
    } else {
      this.storageService.setPreviewFromPublish(true);
      const dialogRef = this.dialog.open(PreviewBannerDialogComponent, {
        id: environment.applicationName + '-preview-dialog-container',
        height: '98%',
        width: '100vw',
        maxWidth: '95vw',
        panelClass: 'full-screen-modal',
        position: { top: '10px' },
        data: this.selection.selected[0]
      });
      dialogRef.afterClosed().subscribe(result => {
      });
    }
  }
}

@Component({
  selector: 'app-preview-banner-component',
  templateUrl: './preview-banner.html',
  styleUrls: ['./manage-banner.component.scss']

})
export class PreviewBannerDialogComponent implements OnInit {
  public theme: string = environment.applicationName;
  public selectedApplication = this.adminService.selectedApplication;
  public featureInfo = [];
  constructor(
    public dialogRef: MatDialogRef<ManageBannerComponent>,
    private adminService: AdminService, @Inject(MAT_DIALOG_DATA) public data: any,
    private bannerService: ManageBannerService) {
  }

  public bannerId = this.data.id;

  ngOnInit() {
    this.getSupportTopicByType();
  }

  getSupportTopicByType() {
    this.adminService.getFlow(this.data.contentType.toLowerCase()).subscribe(response => {
      if (response) {
        response.filter(obj => {
          this.featureInfo.push(obj['controls'][0]);
        });
      }
    });
  }

  public getBanner(bannerStatus: string) {
    this.bannerService.getBanner(this.selectedApplication, bannerStatus, this.data).subscribe(response => {
      if (response) {
      }
    });
  }

  close(): void {
    environment.applicationName = 'admin';
    this.dialogRef.close();
  }
}

